export const OPEN_LEGEND_PREVIEW = 'OPEN_LEGEND_PREVIEW';
export const CLOSE_LEGEND_PREVIEW = 'CLOSE_LEGEND_PREVIEW';
export const OPEN_LEGEND_EXPANDED = 'OPEN_LEGEND_EXPANDED';
export const CLOSE_LEGEND_EXPANDED = 'CLOSE_LEGEND_EXPANDED';
export const RESET_LISTINGS_INITIAL_LOAD_STATE = 'RESET_LISTINGS_INITIAL_STATE';
export const UPDATE_LISTINGS = 'UPDATE_LISTINGS';
export const UPDATE_LISTING_BAR = 'UPDATE_LISTING_BAR';
export const UPDATE_PREVIEW_LISTINGS = 'UPDATE_PREVIEW_LISTINGS';
export const UPDATE_PREVIEW_LISTING_BAR = 'UPDATE_PREVIEW_LISTING_BAR';
export const MANUALLY_UPDATE_LISTING_BAR = 'MANUALLY_UPDATE_LISTING_BAR';
export const TOGGLE_LISTING_BAR_CHECKBOX = 'TOGGLE_LISTING_BAR_CHECKBOX';

export const createResetListingsInitialLoadStateAction = () => ({
  type: RESET_LISTINGS_INITIAL_LOAD_STATE,
});

export const createUpdateListingsAction = (listingsResult, realEstateType, boundingBox) => ({
  type: UPDATE_LISTINGS,
  listingsResult,
  realEstateType,
  boundingBox,
});

export const createUpdateListingBarAction = (listingsResult, realEstateType, boundingBox) => ({
  type: UPDATE_LISTING_BAR,
  listingsResult,
  realEstateType,
  boundingBox,
});

export const createUpdatePreviewListingsAction = (listingsResult, realEstateType, boundingBox) => ({
  type: UPDATE_PREVIEW_LISTINGS,
  listingsResult,
  realEstateType,
  boundingBox,
});

export const createUpdatePreviewListingBarAction = (listingsResult, realEstateType, boundingBox) => ({
  type: UPDATE_PREVIEW_LISTING_BAR,
  listingsResult,
  realEstateType,
  boundingBox,
});

export const createManuallyUpdateListingBarAction = (realEstateType) => ({
  type: MANUALLY_UPDATE_LISTING_BAR,
  realEstateType,
});
